import type { PropsWithChildren } from 'react';

import {
  signInCard,
  signInOrb1,
  signInOrb2,
  signInOrb3,
  signInPageContainer,
} from './share.css';
export const SignInPageContainer = ({ children }: PropsWithChildren) => {
  return (
    <div className={signInPageContainer}>
      <div className={signInOrb1} />
      <div className={signInOrb2} />
      <div className={signInOrb3} />
      <div className={signInCard}>{children}</div>
    </div>
  );
};
